export const ColosseumConstants = {
  ARENA_WEST: 19,
  ARENA_EAST: 34,
  ARENA_NORTH: 18,
  ARENA_SOUTH: 33,
} as const;
